import { Box, Button, Grid, InputLabel, Link, Typography } from '@material-ui/core'
import { Cancel, CloseSharp, CloudUpload } from '@material-ui/icons'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Header from './header';
import AdminPartnerClient from '../../../Service/Admin/partner_services'
import { ObjectToFormdata } from '../../../Common/Utils/common_utils';
import { GLOBAL_STEPPER_DATA } from '../../../Redux/actions';
import { showSnackbar } from '../../../Components/Snackbar/SnackbarActions'
import StepperService from './StepperService';



function ContractDocumentition(props: any) {
    const global_data = useSelector((state: any) => state.stepperReducer);
    const dispatch = useDispatch();

    const [userData, setUserData]: any = useState([]);
    const [dataArr, setDataArr]: any = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
    let role = sessionStorage.getItem("role");

    const onSubmit = () => {
        onBeforeSubmit();
    }
    const firstElementRef=useRef(null)
    useEffect(() => {
        // alert(global_data.partner_profile)
        // if ( global_data.partner_profile != "") {
            window.scrollTo(0,0);    
            if(firstElementRef.current){
                //@ts-ignore
                firstElementRef.current.scrollIntoView();
              }
        if (global_data.partner_contract_document_id != null) {
            setLoading(true)
            setLoading(true)

            AdminPartnerClient.ContractDocumentition_get('', { partner_profile_id: global_data.partner_profile }).then((response: any) => {
                userData.length = 0;
                setUserData(userData.concat(response.data));
                setLoading(false)
            }).catch(() => { setLoading(false) });

        }
    }, [])

    const onBack = () => {
        props.parentHandleNext(props.activeIndex - 1)
    }
    const onImageChange = (event: any) => {
        console.log(event.target.files[0])
        var localArr = [];
        var pdata = {
            "attributes": {
                "document": event.target.files[0],
                "created_at": "2021-04-08T12:06:08.000Z",
                "file_name": event.target.files[0].name
            },
            id: userData.length + 1
        }
        localArr.push(pdata)
        setDataArr(dataArr.concat(localArr));
        setUserData(userData.concat(localArr));
        // onBeforeSubmit();
    }
    const onBeforeSubmit = () => {
        var flag = true;

        // if (role == "admin" && dataArr.length == 0) {
        //     flag = false;
        // }
        if (flag) {
            setSubmitClickFlag(false)

            var docArr: any = [];
            dataArr.map((option: any) => {
                docArr.push(option.attributes.document)
            })
            setLoading(true)



            AdminPartnerClient.ContractDocumentition(ObjectToFormdata({
                partner_profile_id: global_data.partner_profile, document: docArr.length > 0 ? (docArr) : []
            })).then((response: any) => {
                if (response.data.length > 0) {
                    let test = response.data;
                    let finalVal = test.map((row: any) => row.id)
                    dispatch({ type: GLOBAL_STEPPER_DATA, payload: { partner_contract_document_id: finalVal } });
                }
                props.parentHandleNext(props.activeIndex + 1)
                dispatch(showSnackbar("Success", ["Information saved successfully"]))
                setLoading(false)
            }).catch(() => { setLoading(false) });
        } else {
            setSubmitClickFlag(true)

        }
    }
    console.log(userData)

    return (
        <div style={{ marginBottom: 40 }} ref={firstElementRef}>
            {console.log(userData)}
            {/* <Header isBack={true} saveBtnTitle={'Save & Proceed'} parentcall={onSubmit} parentBackCall={onBack} /> */}

            <Grid container direction="row" alignItems="center" style={{ padding: 30, marginBottom: 30 }}>
                <Grid item xs={10}>
                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 30 }}>
                        <Grid item xs={4}>
                            <Typography variant="h2">Documents</Typography>
                        </Grid>
                        <Grid item xs={8} >
                            <label htmlFor="upload-photo">
                                <input onChange={(e) => { onImageChange(e) }}
                                    // accept="application/pdf, application/vnd.ms-excel,image/gif, image/jpeg, application/msword, application/vnd.ms-powerpoint"
                                    accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                                    style={{ display: 'none' }} id="upload-photo" multiple={true} name="upload-photo" type="file" />
                                <Button disableElevation color="secondary" variant="contained" component="span" style={{ fontSize: 12 }}><CloudUpload style={{ marginRight: 10 }} />Upload</Button>
                                {/* {submitClickFlag && userData.length == 0 && <Typography variant="body1" style={{ color: "red" }}><Box>* Please upload contract documents</Box></Typography>} */}
                            </label>

                        </Grid>
                    </Grid>

                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={4}></Grid>
                        <Grid item xs={8} >
                            {StepperService.uploadImageCard(userData, setUserData, '/partner_contract_documents/', null, dispatch)}
                        </Grid>
                    </Grid>



                </Grid>
            </Grid>
            <Header isBack={true} saveBtnTitle={'Save & Proceed'} parentcall={onSubmit} parentBackCall={onBack} />
        </div>
    )
}

export default ContractDocumentition
